package cc.bluepeak.clubmanager.site.styles

import com.varabyte.kobweb.compose.css.Outline
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderBottom
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.opacity
import com.varabyte.kobweb.compose.ui.modifiers.outline
import com.varabyte.kobweb.silk.components.forms.InputVars
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.selectors.focus
import com.varabyte.kobweb.silk.style.selectors.focusVisible
import com.varabyte.kobweb.silk.style.selectors.focusWithin
import com.varabyte.kobweb.silk.style.selectors.hover
import com.varabyte.kobweb.silk.style.selectors.placeholder
import com.varabyte.kobweb.silk.theme.colors.palette.color
import com.varabyte.kobweb.silk.theme.colors.palette.toPalette
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.px

val UnderlinedTextAreaStyle = CssStyle {
    val palette = colorMode.toSitePalette()
    base {
        Modifier.border(0.px).borderBottom(1.px, LineStyle.Solid, palette.secondary)
            .fontFamily("Urbanist")
            .color(colorMode.toPalette().color)
            .outline(Outline.Unset)
            .fontSize(InputVars.FontSize.value())
            .backgroundColor(Colors.Transparent)
    }
    placeholder {
        Modifier
            .opacity(InputVars.PlaceholderOpacity.value())
            .color(InputVars.PlaceholderColor.value())
    }
    hover {
        Modifier.borderBottom(1.px, LineStyle.Solid, palette.primary)
    }
    focusVisible {
        Modifier.borderBottom(1.px, LineStyle.Solid, palette.primary)
    }
    focus {
        Modifier.borderBottom(1.px, LineStyle.Solid, palette.primary)
    }
    focusWithin {
        Modifier.borderBottom(1.px, LineStyle.Solid, palette.primary)
    }
}